(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirefb24"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirefb24"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("7rhnA", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $56a8893181262552$export$6503ec6e8aabbaf; }, function (v) { return $56a8893181262552$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $56a8893181262552$export$f7ad0328861e2f03; }, function (v) { return $56a8893181262552$export$f7ad0328861e2f03 = v; });
var $56a8893181262552$export$6503ec6e8aabbaf;
var $56a8893181262552$export$f7ad0328861e2f03;
"use strict";
var $56a8893181262552$var$mapping = new Map();
function $56a8893181262552$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$56a8893181262552$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $56a8893181262552$var$resolve(id) {
    var resolved = $56a8893181262552$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$56a8893181262552$export$6503ec6e8aabbaf = $56a8893181262552$var$register;
$56a8893181262552$export$f7ad0328861e2f03 = $56a8893181262552$var$resolve;

});

parcelRegister("hYuMa", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $d15fe9b19fd0db3b$export$bdfd709ae4826697; }, function (v) { return $d15fe9b19fd0db3b$export$bdfd709ae4826697 = v; });
var $d15fe9b19fd0db3b$export$bdfd709ae4826697;
var $d15fe9b19fd0db3b$export$c9e73fbda7da57b6;
var $d15fe9b19fd0db3b$export$5a759dc7a1cfb72a;
"use strict";
var $d15fe9b19fd0db3b$var$bundleURL = {};
function $d15fe9b19fd0db3b$var$getBundleURLCached(id) {
    var value = $d15fe9b19fd0db3b$var$bundleURL[id];
    if (!value) {
        value = $d15fe9b19fd0db3b$var$getBundleURL();
        $d15fe9b19fd0db3b$var$bundleURL[id] = value;
    }
    return value;
}
function $d15fe9b19fd0db3b$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $d15fe9b19fd0db3b$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $d15fe9b19fd0db3b$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $d15fe9b19fd0db3b$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$d15fe9b19fd0db3b$export$bdfd709ae4826697 = $d15fe9b19fd0db3b$var$getBundleURLCached;
$d15fe9b19fd0db3b$export$c9e73fbda7da57b6 = $d15fe9b19fd0db3b$var$getBaseURL;
$d15fe9b19fd0db3b$export$5a759dc7a1cfb72a = $d15fe9b19fd0db3b$var$getOrigin;

});

var $40a9e4e088585f40$exports = {};


(parcelRequire("7rhnA")).register((parcelRequire("hYuMa")).getBundleURL("8YKCQ"), JSON.parse('["8YKCQ","index.b329a8ca.js","cLokK","Grocery.f2ec22d0.js"]'));

})();
//# sourceMappingURL=index.runtime.1197b40d.js.map
